export default __webpack_public_path__ + "static/media/3.5ea29991.jpg";